@if (open) {
  <div class="modal-overlay" (click)="onOverlayClick($event)">
    <div class="modal-sheet" role="dialog">

      <div class="modal-header">
        <h2 class="modal-title">{{ title }}</h2>
        <p class="modal-subtitle">{{ subtitle }}</p>
      </div>

      <ul class="modal-options">
        @for (option of options; track option.id) {
          <li
            class="modal-option"
            [class.modal-option--selected]="isSelected(option.id)"
            (click)="toggle(option.id)"
          >
            <span class="option-label">{{ option.label }}</span>

            <span class="option-radio">
              @if (isSelected(option.id)) {
                <span class="option-radio__dot"></span>
              }
            </span>
          </li>
        }
      </ul>

    </div>
  </div>
}